

export const frontMatter = {
	slug: 'dockview-1.6.0-release',
	title: 'Dockview 1.6.0',
	tags: [
		'release'
	]
};
export const contentTitle = 'Release Notes';
export const metadata = {
  "permalink": "/blog/dockview-1.6.0-release",
  "source": "@site/blog/2023-02-26-dockview-1.6.0.mdx",
  "title": "Dockview 1.6.0",
  "description": "Please reference to docs @ dockview.dev.",
  "date": "2023-02-26T00:00:00.000Z",
  "formattedDate": "February 26, 2023",
  "tags": [
    {
      "label": "release",
      "permalink": "/blog/tags/release"
    }
  ],
  "readingTime": 0.74,
  "hasTruncateMarker": false,
  "authors": [],
  "frontMatter": {
    "slug": "dockview-1.6.0-release",
    "title": "Dockview 1.6.0",
    "tags": [
      "release"
    ]
  },
  "unlisted": false,
  "prevItem": {
    "title": "Dockview 1.7.0",
    "permalink": "/blog/dockview-1.7.0-release"
  },
  "nextItem": {
    "title": "Dockview 1.5.2",
    "permalink": "/blog/dockview-1.5.2-release"
  }
};
export const assets = {
"authorsImageUrls": [],
};

import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
import Link from '@docusaurus/Link';
export const toc = [{
  "value": "🚀 Features",
  "id": "-features",
  "level": 2
}, {
  "value": "🛠 Miscs",
  "id": "-miscs",
  "level": 2
}, {
  "value": "🔥 Breaking changes",
  "id": "-breaking-changes",
  "level": 2
}];
function _createMdxContent(props) {
  const _components = {
    a: "a",
    h2: "h2",
    li: "li",
    p: "p",
    ul: "ul",
    ..._provideComponents(),
    ...props.components
  };
  return _jsxs(_Fragment, {
    children: [_jsxs(_components.p, {
      children: ["Please reference to docs @ ", _jsx(_components.a, {
        href: "https://dockview.dev",
        children: "dockview.dev"
      }), ".\nIf you feel anything is missing or unclear please let me know."]
    }), "\n", _jsx(_components.h2, {
      id: "-features",
      children: "🚀 Features"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: ["Allow drag events to edge of dockview containers ", _jsx(_components.a, {
          href: "https://github.com/mathuo/dockview/pull/177",
          children: "#177"
        })]
      }), "\n", _jsxs(_components.li, {
        children: ["group dnd ", _jsx(_components.a, {
          href: "https://github.com/mathuo/dockview/pull/171",
          children: "#171"
        })]
      }), "\n", _jsxs(_components.li, {
        children: ["full width tabs ", _jsx(_components.a, {
          href: "https://github.com/mathuo/dockview/pull/177",
          children: "#171"
        })]
      }), "\n", _jsx(_components.li, {
        children: "addPanel improvements"
      }), "\n", _jsx(_components.li, {
        children: "update parameters via panel.api.updateParameters"
      }), "\n", _jsxs(_components.li, {
        children: ["allow dnd on empty groups ", _jsx(_components.a, {
          href: "https://github.com/mathuo/dockview/pull/168",
          children: "#168"
        })]
      }), "\n", _jsxs(_components.li, {
        children: ["Change watermark logic ", _jsx(_components.a, {
          href: "https://github.com/mathuo/dockview/pull/194",
          children: "#194"
        })]
      }), "\n"]
    }), "\n", _jsx(_components.h2, {
      id: "-miscs",
      children: "🛠 Miscs"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: ["Fix dockview panel.api.setSize to work as expected ", _jsx(_components.a, {
          href: "https://github.com/mathuo/dockview/pull/184",
          children: "#184"
        })]
      }), "\n", _jsxs(_components.li, {
        children: ["Fix dockview setTitle ", _jsx(_components.a, {
          href: "https://github.com/mathuo/dockview/pull/190",
          children: "#190"
        })]
      }), "\n", _jsxs(_components.li, {
        children: ["Fix group dnd logic to filter for same dockview instance ", _jsx(_components.a, {
          href: "https://github.com/mathuo/dockview/pull/193",
          children: "#185"
        })]
      }), "\n", _jsxs(_components.li, {
        children: ["Update dependencies including the dev dependencies for dockview and all dependencies for the docs website.\n", _jsx(_components.a, {
          href: "https://github.com/mathuo/dockview/pull/180",
          children: "#180"
        })]
      }), "\n", _jsx(_components.li, {
        children: "A variety of internal changes including file name changes"
      }), "\n", _jsx(_components.li, {
        children: "Improve internal dnd control logic to handle a wider variety of cases"
      }), "\n", _jsxs(_components.li, {
        children: ["Various doc enhancements @ ", _jsx(_components.a, {
          href: "https://dockview.dev",
          children: "dockview.dev"
        })]
      }), "\n"]
    }), "\n", _jsx(_components.h2, {
      id: "-breaking-changes",
      children: "🔥 Breaking changes"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsx(_components.li, {
        children: "addEmptyGroup renamed to addGroup"
      }), "\n"]
    })]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = {
    ..._provideComponents(),
    ...props.components
  };
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}

